/* PKW GUTACHTER Theme – Basis-Skripte
   Enthaelt: Farbschema (hell/dunkel), Mobilnavigation, Zahlart-Popover,
   Warenkorb-Drawer via Shopify Cart-AJAX-API, Nach-oben-Button. */
(function () {
  "use strict";

  /* ---------- Farbschema ----------

     WARUM HIER DREI ZUSTAENDE UNTERSCHIEDEN WERDEN

     maximal.css bestimmt die Farben auf ZWEI Wegen:

       :root                                        die hellen Grundwerte
       @media(prefers-color-scheme:dark)
         :root:not([data-theme="light"])            das Geraet steht dunkel
       :root[data-theme="dark"]                     ausdrueckliche Wahl

     Daraus folgt: OHNE Attribut ist die Seite auf einem dunkel
     eingestellten Geraet dunkel. Das Attribut fehlt beim ersten Besuch
     naemlich immer.

     Die alte Fassung dieser Datei hat beim Umschalten auf hell das
     Attribut ENTFERNT statt es auf "light" zu setzen. Auf einem dunkel
     eingestellten Geraet passierte damit genau nichts - die Media-Query
     griff sofort wieder, die Seite blieb dunkel, und nur das Logo sprang
     auf die falsche Fassung um. Der Knopf "Hell" hat die Seite also nicht
     hell gemacht, er hat das Logo kaputtgemacht. Gemessen am 03.09.2026.

     Deshalb jetzt: das Attribut wird IMMER gesetzt, auch auf "light", und
     der Ausgangszustand wird nicht mehr am Attribut abgelesen, sondern am
     tatsaechlich sichtbaren Zustand. Sonst braeuchte der erste Klick auf
     einem dunklen Geraet zwei Anlaeufe: einmal, um das Attribut ueberhaupt
     zu setzen, und einmal, um es zu wechseln. */
  function istDunkel() {
    var a = document.documentElement.getAttribute("data-theme");
    if (a === "dark") { return true; }
    if (a === "light") { return false; }
    return !!(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
  }

  function updateThemeBtn() {
    var dark = istDunkel();
    var b = document.getElementById("themeBtn");
    if (b) { b.textContent = dark ? window.THEME_STRINGS.light : window.THEME_STRINGS.dark; }
  }

  window.toggleTheme = function () {
    var t = istDunkel() ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", t);
    try { localStorage.setItem("theme", t); } catch (e) {}
    updateThemeBtn();
  };

  /* Aendert jemand die Einstellung seines Geraets, waehrend die Seite
     offen ist, soll die Seite mitgehen - aber nur, solange er hier nicht
     selbst gewaehlt hat. Die Farben macht CSS von allein; hier geht es
     nur um die Beschriftung des Knopfes, die sonst das Gegenteil des
     Sichtbaren behauptet. */
  if (window.matchMedia) {
    var mq = window.matchMedia("(prefers-color-scheme: dark)");
    var horch = function () {
      if (!document.documentElement.getAttribute("data-theme")) { updateThemeBtn(); }
    };
    if (mq.addEventListener) { mq.addEventListener("change", horch); }
    else if (mq.addListener) { mq.addListener(horch); }
  }

  /* ---------- Mobilnavigation ---------- */
  window.toggleNav = function () {
    var n = document.getElementById("mainnav");
    if (n) { n.classList.toggle("open"); }
  };

  /* ---------- Zahlart-Popover im Footer ---------- */
  var payPopEl = null, payOpenKey = null;
  function closePayPop() {
    if (payPopEl) { payPopEl.remove(); payPopEl = null; }
    payOpenKey = null;
  }
  window.payPop = function (btn, key) {
    if (payOpenKey === key) { closePayPop(); return; }
    closePayPop();
    var info = (window.PAY_INFO || {})[key];
    if (!info) { return; }
    var el = document.createElement("div");
    el.className = "pay-pop";
    el.setAttribute("role", "dialog");
    var t = document.createElement("strong"); t.textContent = info[0];
    var s = document.createElement("span"); s.textContent = info[1];
    el.appendChild(t); el.appendChild(s);
    document.body.appendChild(el);
    var r = btn.getBoundingClientRect();
    var top = r.top - el.offsetHeight - 10;
    if (top < 10) { top = r.bottom + 10; }
    var left = r.left + r.width / 2 - el.offsetWidth / 2;
    left = Math.max(10, Math.min(left, window.innerWidth - el.offsetWidth - 10));
    el.style.top = (top + window.scrollY) + "px";
    el.style.left = (left + window.scrollX) + "px";
    requestAnimationFrame(function () { el.classList.add("show"); });
    payPopEl = el; payOpenKey = key;
  };
  document.addEventListener("click", function (e) {
    if (payPopEl && !(e.target.closest && e.target.closest(".pay-pop"))) { closePayPop(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closePayPop(); closeDrawer(); }
  });
  window.addEventListener("resize", closePayPop);

  /* ---------- Warenkorb ---------- */
  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(".", ",");
    return n + " €";
  }
  function isFree(cents) { return cents === 0; }

  /* Alles, was aus dem Warenkorb kommt, ist am Ende vom Kunden getippt:
     Kennzeichen, Schadenbeschreibung, Versicherungsnummer. Das darf nicht
     als HTML in die Seite. */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c];
    });
  }

  function openDrawer() {
    var d = document.getElementById("drawer"), bg = document.getElementById("drawerBg");
    if (!d) { return; }
    d.classList.add("open"); if (bg) { bg.classList.add("show"); }
  }
  function closeDrawer() {
    var d = document.getElementById("drawer"), bg = document.getElementById("drawerBg");
    if (!d) { return; }
    d.classList.remove("open"); if (bg) { bg.classList.remove("show"); }
  }
  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;

  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? "" : "none";
    });
  }

  /* Zusatzangaben einer Warenkorbzeile.

     Sie stehen mit im Drawer, weil sie der Grund sind, warum die Bestellung
     ueberhaupt bearbeitet werden kann: wer auf der Produktseite Kennzeichen,
     Unfalldatum und Standort eintraegt, muss vor dem Bezahlen sehen, dass
     sie angekommen sind - und einen Zahlendreher noch bemerken koennen.

     Namen, die mit einem Unterstrich beginnen, sind Shopify-Konvention fuer
     technische Felder und bleiben unsichtbar. */
  function eigenschaften(it) {
    var p = it.properties;
    if (!p) { return ""; }
    var zeilen = Object.keys(p).filter(function (k) {
      return k.charAt(0) !== "_" && p[k] !== null && String(p[k]).trim() !== "";
    }).map(function (k) {
      return "<li><b>" + esc(k) + ":</b> " + esc(p[k]) + "</li>";
    });
    return zeilen.length ? '<ul class="wk-eig">' + zeilen.join("") + "</ul>" : "";
  }

  function renderDrawer(cart) {
    var items = document.getElementById("drawerItems");
    var foot = document.getElementById("drawerFoot");
    if (!items) { return; }
    setCount(cart.item_count);
    if (!cart.items.length) {
      items.innerHTML = '<p class="d-empty">' + esc(window.THEME_STRINGS.cartEmpty) + "</p>";
      if (foot) { foot.style.display = "none"; }
      return;
    }
    var html = "";
    cart.items.forEach(function (it) {
      var price = isFree(it.line_price)
        ? '<div class="d-price free">' + esc(window.THEME_STRINGS.free) + "</div>"
        : '<div class="d-price">' + money(it.line_price) + "</div>";
      /* Die Ausfuehrung gehoert sichtbar dazu: beim Buch entscheidet sie
         zwischen Hardcover und E-Book, beim Gutschein ueber den Betrag. */
      var vari = (it.variant_title && it.variant_title !== "Default Title")
        ? '<div class="wk-var">' + esc(it.variant_title) + "</div>" : "";
      html += '<div class="d-item"><div class="d-info"><h4>' + esc(it.product_title) + "</h4>" +
        vari + price + eigenschaften(it) +
        '</div><div class="d-qty">' +
        '<button type="button" aria-label="minus" onclick="cartChange(\'' + esc(it.key) + "'," + (it.quantity - 1) + ')">&minus;</button>' +
        "<span>" + it.quantity + "</span>" +
        '<button type="button" aria-label="plus" onclick="cartChange(\'' + esc(it.key) + "'," + (it.quantity + 1) + ')">+</button>' +
        "</div></div>";
    });
    items.innerHTML = html;
    var tot = document.getElementById("dTotal");
    if (tot) { tot.textContent = isFree(cart.total_price) ? window.THEME_STRINGS.free : money(cart.total_price); }
    if (foot) { foot.style.display = "block"; }
  }

  function fetchCart(cb) {
    fetch(window.Shopify.routes.root + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderDrawer(c); if (cb) { cb(c); } })
      .catch(function () {});
  }
  window.refreshCart = fetchCart;

  window.cartChange = function (key, qty) {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); })
      .then(function (c) {
        renderDrawer(c);
        if (document.body.classList.contains("template-cart")) { location.reload(); }
      });
  };

  /* Ein Formular in genau die Nutzlast uebersetzen, die cart/add.js erwartet.

     Warum ueber FormData und nicht ueber einzeln herausgesuchte Felder:
     die Produktseite haengt ihre Auftragsfelder als properties[...] an das
     Bestellformular. Wer nur id und quantity abholt, wirft Kennzeichen,
     Unfalldatum, Standort und Telefonnummer weg - die Bestellung kommt an,
     aber ohne die Angaben, wegen derer sie ueberhaupt bearbeitbar waere.
     Mit FormData wandert jedes Feld mit, auch ein Feld, das erst morgen im
     Adminbereich dazukommt.

     Leere Felder werden ausgelassen. Shopify macht es beim gewoehnlichen
     Absenden genauso; sonst stuenden in jeder Bestellung neun Zeilen, von
     denen die Haelfte leer ist. */
  function formToItem(f) {
    var item = { id: 0, quantity: 1 }, props = {}, hat = false;
    new FormData(f).forEach(function (v, k) {
      if (k === "id") { item.id = parseInt(v, 10); return; }
      if (k === "quantity") { item.quantity = parseInt(v, 10) || 1; return; }
      if (k.slice(0, 11) === "properties[" && k.slice(-1) === "]") {
        var name = k.slice(11, -1);
        if (String(v).trim() !== "") { props[name] = v; hat = true; }
      }
    });
    if (hat) { item.properties = props; }
    return item;
  }

  /* Legt eine fertige Zeile in den Warenkorb.
     formular ist der Rueckfallweg: schlaegt die Anfrage fehl, wird das
     Formular gewoehnlich abgeschickt. Frueher fuehrte der Fehlerfall auf die
     Warenkorbseite - die Eingaben waren damit weg. */
  function addItem(item, btn, formular) {
    var label = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = window.THEME_STRINGS.adding; }
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) { throw new Error("add failed"); }
      return r.json();
    }).then(function () {
      /* Erst melden, dann den Drawer oeffnen. Das Ereignis traegt den
         gedrueckten Knopf mit sich; konfetti.js laesst daraus einen kurzen
         Schwung Konfetti springen. Ueber ein Ereignis und nicht ueber einen
         direkten Aufruf, damit diese Datei nichts ueber Konfetti wissen
         muss - ist es abgeschaltet, hoert schlicht niemand zu.

         Die Meldung steht bewusst NUR im Erfolgsfall: Konfetti bei einem
         fehlgeschlagenen Warenkorb-Zugang waere Hohn. */
      try {
        document.dispatchEvent(new CustomEvent("cart:added", {
          detail: { knopf: btn, id: item.id, menge: item.quantity }
        }));
      } catch (e) {}
      fetchCart();
      openDrawer();
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }).catch(function () {
      if (formular) { formular.submit(); return; }
      window.location.href = window.Shopify.routes.root + "cart";
    });
  }
  window.addItem = addItem;

  window.addToCart = function (variantId, qty, btn, props) {
    var item = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (props && Object.keys(props).length) { item.properties = props; }
    return addItem(item, btn, null);
  };

  /* Formulare mit data-add-to-cart abfangen */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f.matches || !f.matches("form[data-add-to-cart]")) { return; }
    var item = formToItem(f);
    if (!item.id) { return; }
    e.preventDefault();
    /* e.submitter ist der Knopf, der tatsaechlich gedrueckt wurde - auch
       dann, wenn er ueber das form-Attribut ausserhalb des Formulars steht,
       wie der zweite Bestellknopf unter dem Bild auf der Produktseite.
       Ohne das bekaeme immer der erste Knopf IM Formular die Rueckmeldung
       "wird hinzugefuegt" - also gerade der, den man in dem Moment nicht
       sieht. Aeltere Safari-Versionen kennen submitter nicht; dort greift
       der alte Weg. */
    var knopf = e.submitter || f.querySelector("button[type=submit]");
    addItem(item, knopf, f);
  });

  /* Mengen-Stepper */
  window.qtyStep = function (btn, delta) {
    var input = btn.parentNode.querySelector("input");
    if (!input) { return; }
    var v = (parseInt(input.value, 10) || 1) + delta;
    input.value = Math.max(1, v);
  };

  /* ---------- Video ----------
     Der Player wird erst beim Klick geladen. Bis dahin steht dort nur ein
     Standbild, es geht keine Anfrage an Stornaway und es wird kein Cookie
     gesetzt. */
  window.startVideo = function (btn) {
    var box = btn.parentNode;
    var src = box.getAttribute("data-vid-src");
    if (!src) { return; }
    var f = document.createElement("iframe");
    f.setAttribute("src", src);
    f.setAttribute("title", btn.getAttribute("data-title") || "Video");
    f.setAttribute("frameborder", "0");
    f.setAttribute("allow", "autoplay; fullscreen; encrypted-media");
    f.setAttribute("allowfullscreen", "allowfullscreen");
    box.innerHTML = "";
    box.appendChild(f);
    f.focus();
  };

  /* ---------- Hoehe der Servicezeile ----------
     Die Zeile liegt fest oben und der Seiteninhalt bekommt genau so viel
     Abstand nach oben, wie sie hoch ist. Bricht sie um - schmales Fenster,
     zusaetzlicher Eintrag -, waechst der Abstand mit. */
  function fitTopbar() {
    var tb = document.querySelector(".topbar");
    if (!tb) { return; }
    var h = Math.round(tb.getBoundingClientRect().height);
    if (h > 0) { document.documentElement.style.setProperty("--topbar-h", h + "px"); }
  }
  window.addEventListener("resize", fitTopbar);
  window.addEventListener("load", fitTopbar);
  document.addEventListener("shopify:section:load", fitTopbar);

  /* ---------- Nach oben ---------- */
  function onScroll() {
    var t = document.getElementById("totop");
    if (t) { t.classList.toggle("show", window.scrollY > 600); }
  }
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- Init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    updateThemeBtn();
    fitTopbar();
    onScroll();
    if (document.getElementById("drawer")) { fetchCart(); }
  });
})();
